import type { ToastType } from '@/contexts/ToastContext'
import styles from './AlertBanner.module.css'

const ICONS: Record<ToastType, string> = {
  success: '✓',
  error: '!',
  warning: '⚠',
  info: 'i',
}

type Props = {
  variant: ToastType
  message: string
  title?: string
  onDismiss?: () => void
}

export function AlertBanner({ variant, message, title, onDismiss }: Props) {
  return (
    <div className={`${styles.banner} ${styles[`banner--${variant}`]}`} role="alert">
      <span className={styles.icon} aria-hidden>
        {ICONS[variant]}
      </span>
      <div className={styles.body}>
        {title && <span className={styles.title}>{title}</span>}
        <p className={styles.message}>{message}</p>
      </div>
      {onDismiss && (
        <button type="button" className={styles.dismiss} onClick={onDismiss} aria-label="Fechar">
          ×
        </button>
      )}
    </div>
  )
}
